export default {
	// used for removing some elements in mobile screens portrait mode (desktop-first design)
	// NOTE: when updating this value, also update in `tailwind.config.js`
	mobile: 639,
	// Tailwind 1.x defaults (mobile-first design):
	sm: 640,
	md: 768,
	lg: 1024,
	xl: 1280,
}
